import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'retirement-plan',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RadioButtonModule,
        TooltipModule,
    ],
    templateUrl: './retirement-plan.component.html',
    styleUrls: ['./retirement-plan.component.scss'],
    standalone: true,
})
export class RetirementPlanComponent implements OnInit {
    @Input() form: FormGroup;

    translate = inject(TranslateService);

    constructor() { }

    ngOnInit(): void { }
}
